module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_sand_4-e8eb8e363f01049f115086cfa87e2995.png";